import React, { Component } from 'react';
import { withRouter } from '../../WithRouterHOC';
import { Modal, Select, message } from 'antd';
import HTTP from '../../../script/service';
import OrderRefundModal from './OrderPlayHandle';
import OrderRefuseModal from './OrderGodHandle';
import './CancelOrder.scss';

class CancelOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      order: null,
      type: undefined,
      godUid: null,
      playUid: null,
      loading: false,
      cancelType: 15, //15 老板取消订单  //16大神拒绝接单  17老板申请退款  18大神拒绝退款
    };
  }
  componentDidMount() {
    window.showModal = this.showModal;
  }

  showModal = (param) => {
    this.setState(
      {
        visible: true,
        loading: true,
        type: undefined,
        uid: param.uid,
        orderId: param.orderId,
        cancelType: param.cancelType,
      },
      () => {
        HTTP._get_order_detail({
          uid: this.state.uid,
          orderId: this.state.orderId,
        }).then((res) => {
          if (res?.code === 200 && res.data) {
            let godUid = this.state.uid;
            if (res.data.godInfo) {
              godUid = res.data.godInfo.uid;
            }
            this.setState({
              order: res.data,
              godUid: godUid,
              playUid: res.data.playUid,
              loading: false,
            });
          } else {
            this.setState({
              order: null,
              loading: false,
            });
            message.error('订单不存在');
            this.hideModal();
          }
        });
      }
    );
  };
  hideModal = () => {
    this.setState({
      visible: false,
    });
  };
  cTypeChange = (n) => {
    this.setState({
      type: n,
    });
  };
  changeOrderStatus = () => {
    const { type, cancelType, order, playUid, godUid } = this.state;
    if (!type) {
      message.warning('请选择原因/理由');
      return;
    }
    let uid = playUid;
    let orderStatus = cancelType;
    if (cancelType == 16 || cancelType == 18) {
      uid = godUid;
    }
    if (cancelType == 17) {
      orderStatus = 6;
    }
    if (cancelType == 18) {
      orderStatus = 8;
    }
    HTTP._modified_order({
      uid: uid,
      orderId: order.orderId,
      orderStatus: orderStatus,
      cancelReason: type,
    }).then((res) => {
      if (res?.code === 200) {
        this.props.reload();
        this.hideModal();
      } else {
        message.warning(res?.message || '操作失败，请稍后重试哦~');
      }
    });
  };

  renderOrderContent = () => {
    const { type, order, cancelType } = this.state;

    if (!order) {
      return (
        <div className="cancel-modal-order">
          <div className="not-err-msg">订单已过期</div>
        </div>
      );
    } else if (
      order.orderStatus != 2 &&
      order.orderStatus != 4 &&
      order.orderStatus != 6
    ) {
      return (
        <div className="cancel-modal-order">
          <div className="not-err-msg">订单状态已更新，请刷新后重试。</div>
        </div>
      );
    } else {
      return (
        <div>
          {/* 玩家取消订单 */}
          {cancelType == 15 ? (
            <div className="cancel-modal-order">
              <h3>确定取消订单吗?</h3>
              <div className="cancel-row">
                <label className="row-label">
                  <em>*</em>
                  取消原因：
                </label>
                <div className="row-control">
                  <Select
                    placeholder="请选择取消原因"
                    onChange={this.cTypeChange}
                    style={{ width: 230 }}
                    value={type}
                  >
                    <Select.Option value="1">大神未响应</Select.Option>
                    <Select.Option value="2">我就试试怎么下单</Select.Option>
                    <Select.Option value="3">订单信息填写有误</Select.Option>
                    <Select.Option value="4">
                      我临时有事，不想玩了
                    </Select.Option>
                    <Select.Option value="5">大神要求取消</Select.Option>
                    <Select.Option value="6">其他</Select.Option>
                  </Select>
                </div>
              </div>
              <div className="row-msg-text">{`您每天有${order.playCancelCount}次取消订单的机会（${order.playCurrentCount}/${order.playCancelCount}）`}</div>
              <div className="row-actions">
                <button className="daidai-btn" onClick={this.hideModal}>
                  我再想想
                </button>
                <button
                  className={
                    order.currentCount >= order.cancelCount
                      ? 'daidai-btn-disable'
                      : 'daidai-btn-primary'
                  }
                  disabled={
                    order.currentCount >= order.cancelCount ? true : false
                  }
                  onClick={this.changeOrderStatus}
                >
                  确定取消
                </button>
              </div>
            </div>
          ) : null}
          {/* 大神拒绝接单 */}
          {cancelType == 16 ? (
            <div className="cancel-modal-order">
              {order.isNewUser ? (
                <div className="isNewUser">
                  当前订单为<label>该用户首次在平台下单，</label>
                  如果拒绝您将【三小时】无法上系统推荐位，确定要拒绝订单?
                </div>
              ) : (
                <h3>确定拒绝接单吗?</h3>
              )}
              <div className="cancel-row">
                <label className="row-label">
                  <em>*</em>
                  拒绝理由：
                </label>
                <div className="row-control">
                  <Select
                    placeholder="请选择拒绝理由"
                    onChange={this.cTypeChange}
                    style={{ width: 230 }}
                    value={type}
                  >
                    <Select.Option value="1">用户订单要求涉黄</Select.Option>
                    <Select.Option value="2">
                      我当前有单，无法接单
                    </Select.Option>
                    <Select.Option value="3">
                      我临时有事，不能接单了
                    </Select.Option>
                    <Select.Option value="4">用户要求拒绝</Select.Option>
                    <Select.Option value="5">订单单价太低</Select.Option>
                    <Select.Option value="6">其他</Select.Option>
                  </Select>
                </div>
              </div>
              <div className="row-msg-text">{`您每天有${order.gadCancelCount}次取消订单的机会（${order.gadCurrentCount}/${order.gadCancelCount}）`}</div>
              <div className="row-actions">
                <button className="daidai-btn" onClick={this.hideModal}>
                  我再想想
                </button>
                <button
                  className={
                    order.currentCount >= order.cancelCount
                      ? 'daidai-btn-disable'
                      : 'daidai-btn-primary'
                  }
                  disabled={order.currentCount >= order.cancelCount}
                  onClick={this.changeOrderStatus}
                >
                  确定拒绝
                </button>
              </div>
            </div>
          ) : null}
        </div>
      );
    }
  };

  // 返回对应的组件
  renderReturnModal = () => {
    const { reload } = this.props;
    const { visible, order, cancelType } = this.state;
    if (visible) {
      // 玩家申请退款
      if (cancelType === 17) {
        return (
          <OrderRefundModal
            visible={visible}
            orderInfo={order}
            close={this.hideModal}
            reload={reload}
          />
        );
      }
      // 大神拒绝退款
      if (cancelType === 18) {
        return (
          <OrderRefuseModal
            visible={visible}
            orderInfo={order}
            close={this.hideModal}
            reload={reload}
          />
        );
      }

      return (
        <Modal
          open={visible}
          wrapClassName="daidai-modal-style has-top-border"
          centered={true}
          title="系统提示"
          footer={null}
          keyboard={false}
          maskClosable={false}
          width="500px"
          zIndex="1010"
          onCancel={this.hideModal}
        >
          {this.renderOrderContent()}
        </Modal>
      );
    }
    return null;
  };
  render() {
    return this.renderReturnModal();
  }
}

export default withRouter(CancelOrder, { withRef: true });
